<div @show [formGroup]="formGroup" class="body">

    <app-assign-user-form2 formArrayName="users"></app-assign-user-form2>

</div>